import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { FieldProps } from "formik";
// import DatePicker from "react-datepicker";
import TimeKeeper from 'react-timekeeper';

import FormikFieldCustomProps from "./helpers/FormikFieldCustomProps";

const FloatingTimeInput: React.FC<FormikFieldCustomProps & FieldProps & { changeText?: 'string' }> = ({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  const [show, setShow] = useState(false);
  const [draftTime, setDraftTime] = useState(value || '00:00');

  const openPicker = () => {
    setDraftTime(value || '00:00');
    setShow(true);
  };

  const formatTime = (hour?: number, minute?: number) => {
    if (hour == null || minute == null) return draftTime;
    const hh = String(hour).padStart(2, '0');
    const mm = String(minute).padStart(2, '0');
    return `${hh}:${mm}`;
  };
  return (
    <Form.Group>
      <div className="time-container">
        {

          (value
            ? <Button onClick={openPicker} className="show-sel-time">
              <span className="time-text-cont"><span className="text-primary">{props.label}</span><b>{value}</b></span>
            </Button>
            : <Button className="select-time" onClick={openPicker}>Select {props.label}</Button>)
        }
        {/* <div className={show ? 'show-time-keeper' : 'no-show'}> */}
        {
          show
          && <div className="show-time-keeper">
            <TimeKeeper
                hour24Mode
                switchToMinuteOnHourSelect
                doneButton={() => <span
                  onClick={() => {
                    setFieldValue(name, draftTime);
                    // Defer unmount so react-timekeeper finishes its own DOM
                    // cleanup before React reconciles the removal, preventing
                    // the "removeChild" NotFoundError.
                    setTimeout(() => setShow(false), 0);
                  }}
                  className="react-timekeeper__done-button"
                >
                  {props.placeholder}
                </span>}
                closeOnMinuteSelect={false}
                time={draftTime}
                onChange={(newTime) => {
                  setDraftTime(formatTime(newTime?.hour, newTime?.minute));
                }}
              />
            </div>
          }
        {/* </div> */}
      </div>
      { /*
      <DatePicker
        selected={internal}
        dateFormat="HH:mm"
        timeFormat="HH:mm"
        timeCaption={props.label}
        onChange={date => {
          // correct value
          console.log(date)
          if (date) {
            setInternal(date);
          }
          setFieldValue(
            name,
            // Wrong value going 
            date ? DateTime.fromJSDate(date).toUTC().toFormat(insertFormat) : ""
          );
        }}
        customInput={
          <div className="f-group">
            <input 
            type="text" 
            id={props.id} 
            name={name}
            autoComplete="off"
            placeholder={props.placeholder}
            className="form-control react-datepicker-ignore-onclickoutside"
            value={value}
            disabled={props.disabled}
            />
            {props.label && (
              <Form.Label htmlFor={props.id} className="f-label">
                {props.required ? <b>{props.label}</b> : props.label}
                {props.required && <span className="text-danger">*</span>}
              </Form.Label>
            )}
          </div>
        }
        {...props}
      />
      */ }
      {touched[name] && errors[name] ? (
        <Form.Text className="invalid-feedback">{errors[name]}</Form.Text>
      ) : (
          ""
        )}
    </Form.Group>
  );
};

export default FloatingTimeInput;
